module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-N-shadow.86873be6.png";